module.exports = __webpack_public_path__ + "img/2.447d338.png";